import { CRM_ACTIVITY_ENTITY_TYPES } from '@ayocore/activity/common/activity/constants';
import { registerActivityChatCommand } from '@ayocore/activity/client/extensions';

/**
 * Команда `/contact` — вставка чипа контактного лица в комментарий.
 *
 * Доступна только в threadʼах партнёра и лида, где есть привязка к набору
 * контактных лиц через junction-таблицы. Inline-команда: действие
 * выполняется в композере через `openContactPicker()` без рендера surface.
 * См. контракт `ActivitySlashCommand`.
 */
export const contactMentionActivityChatCommand = registerActivityChatCommand({
  id: 'contact_mention',
  trigger: 'contact',
  label: 'Контактное лицо',
  description: 'Упомянуть в сообщении контактное лицо партнера',
  aliases: ['contact-person', 'cp'],
  inlineHandler: api => api.openContactPicker(),
  isAvailable: context => {
    const type = context.threadEntityType;
    if (!type || !context.threadEntityUuid) return false;
    return (
      type === CRM_ACTIVITY_ENTITY_TYPES.PARTNER || type === CRM_ACTIVITY_ENTITY_TYPES.LEAD
    );
  },
});
